@let b = brand();
<a class="menu-card" [routerLink]="['/menus', b.slug]" [style.background-color]="b.color || '#E8F3FF'">
    <img draggable="false" [fallback] [src]="b.logo_url | bucket" [alt]="b.title || b.short || b.name || 'Restaurant'" [title]="b.name || b.title || b.short || 'Restaurant'"/>
    <div class="tint"></div>
    <p class="m-0 font-bold">{{b.title || b.short || b.name || 'Restaurant'}}</p>
</a>